// this is an autogenerated file from DesignSystem/LeadPreview/mutation-dismiss.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_LeadPreview($lead_id: uuid!, $status: leads_lead_statuses_enum) {
  update_leads_leads_by_pk(
    pk_columns: { id: $lead_id }
    _set: { status: $status }
  ) {
    id
  }
}

`